import { revFY25_01Classifier } from './fy25_01';
import { revFY25_02Classifier } from './fy25_02';
var Revisions = [{
  name: 'fy25.01',
  classifier: revFY25_01Classifier
}, {
  name: 'fy25.02',
  classifier: revFY25_02Classifier
}];
var revisionResultCache = null;
export var getRevisions = function getRevisions() {
  if (revisionResultCache !== null) {
    return revisionResultCache;
  }
  revisionResultCache = [].concat(Revisions);
  return revisionResultCache;
};